import { Agency } from '../types/User';

export type PostAuthDestination = '/choose-plan' | '/unpaid-agency' | null;

/**
 * Single source of truth for "where does this agency's payment state send the
 * user". Used both right after login/registration and by PaymentStatusGuard,
 * so the decision can never diverge between the two call sites.
 *
 * Returns null when no redirect is needed (payment valid, or no agency to
 * evaluate — e.g. a user without an agency proceeds normally).
 */
export function determinePostAuthRoute(agency: Agency | null | undefined): PostAuthDestination {
  if (!agency) return null;
  if (agency.paymentStatus === 'pending') return '/choose-plan';
  if (!agency.isPaymentValid) return '/unpaid-agency';
  return null;
}
